module.exports = __webpack_public_path__ + "static/media/Microcontroller setup.ea96c73a.jpg";